require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./two-things-are-infinite.json") })
        }
      }, "path---two-things-are-infinite");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---two-things-are-infinite!./.cache/json/two-things-are-infinite.json
// module id = 852
// module chunks = 231608221292675